import React from 'react'
import { useNavigate } from 'react-router'
/**
 * Page not found error page
 */
function PageNotFound() {
  const navigate = useNavigate();
  return (
    <div className='flex justify-center py-40'>
      <div className='max-w-2xl text-center'>
        <p className="text-3xl text-amber-500 dark:text-amber-500 mb-5">
          Page Not Found!</p>
        <div onClick={() => navigate("/")} className="cursor-pointer inline-flex items-center font-medium text-blue-600 dark:text-blue-500 hover:underline">
          Go Back Home
          <svg aria-hidden="true" className="w-5 h-5 ml-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
        </div>
      </div>
    </div>
  )
}

export default PageNotFound